<template>
    <g-media-object>
        <template slot="left">
            <network-icon v-if="hasNetwork(task)" :network="task.network.slug"/>
        </template>
        <template>
            <g-typography :value="getTaskTitle(task)" />
        </template>
    </g-media-object>
</template>

<script>
    import TasksMixin from '../../proposals/mixins/TasksMixin';
    import {TIKTOK_SLUG} from '../../../../constants/networks';
    import NetworkIcon from '../../../../../src/components/interface/elements/NetworkIcon.vue';


    export default {
        name:   'CampaignTask',
        components: {
            NetworkIcon,
        },
        mixins: [
            TasksMixin,
        ],
        props: {
            task: {
                type:     Object,
                required: true,
            },
        },
        computed: {
            isTikTok() {
                return !!(this.task.network && this.task.network.slug === TIKTOK_SLUG);
            },
        },
    };
</script>

<style scoped>
    .gi-tiktok {
        width: 1.25em;
        display: inline-block;
        text-align: center;
        margin-right: 2px !important;
        height: 1.5rem;
        margin-left: 3px;
    }
</style>
